import React, { useEffect, useState } from 'react';
import Styled from './ErrorPage.styles';
import { useHistory } from 'react-router-dom';

const ErrorPage = ({ onRecover }) => {
  const [secondsLeft, setSecondsLeft] = useState(5);
  const history = useHistory();
  useEffect(() => {
    if (secondsLeft === 0) {
      // handleGoBack();
      return;
    }

    const timer = setTimeout(() => {
      setSecondsLeft((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [secondsLeft]);

  const handleGoBack = () => {
    const referrer = document.referrer;
    const currentOrigin = window.location.origin;

    if (referrer && referrer.startsWith(currentOrigin)) {
      window.history.back();
    } else {
      if (onRecover) onRecover(); // ✅ Reset the ErrorBoundary
      history.replace('/');
    }
  };

  return (
    <Styled.Wrapper>
      <Styled.Container>
        <Styled.Title>Įvyko klaida!</Styled.Title>
        <Styled.Message>
          Klaida užregistruota, atsiprašome už nepatogumus.
          <Styled.Button onClick={handleGoBack}>
            Grįžti ({secondsLeft})
          </Styled.Button>
        </Styled.Message>
      </Styled.Container>
    </Styled.Wrapper>
  );
};

export default ErrorPage;
